import React, { useState, useEffect } from "react";
import { Button } from "@lemonadetraining/web-ui";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import YouTubeEmbed from "../video/YouTubeEmbed";

interface MultipleYouTubeViewProps {
  youTubeIDs: string[];
}

export const MultipleYouTubeView: React.FC<MultipleYouTubeViewProps> = ({
  youTubeIDs: propIDs,
}) => {
  const [youTubeIDs, setYouTubeIDs] = useState<string[]>(propIDs || []);
  const [page, setPage] = useState(1);

  // Sync with prop changes
  useEffect(() => {
    setYouTubeIDs(propIDs);
    // Reset to page 1 if current page would be out of bounds
    setPage((prev) => (prev > propIDs.length ? 1 : prev));
  }, [propIDs]);

  const totalPages = youTubeIDs.length || 1;

  return (
    <div className="flex flex-col items-center gap-2">
      <YouTubeEmbed
        key={youTubeIDs[page - 1]}
        id={youTubeIDs[page - 1]}
        title={totalPages > 1 ? `Workout video ${page} of ${totalPages}` : "Workout video"}
        className="w-[500px] max-w-full rounded-none"
      />
      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="icon"
            className="size-7"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
          >
            <IconChevronLeft className="size-4" />
          </Button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <Button
              key={p}
              variant={p === page ? "selected" : "outline"}
              size="icon"
              className="size-7 text-xs"
              onClick={() => setPage(p)}
            >
              {p}
            </Button>
          ))}
          <Button
            variant="outline"
            size="icon"
            className="size-7"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page >= totalPages}
          >
            <IconChevronRight className="size-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default MultipleYouTubeView;
